import { render, staticRenderFns } from "./AsynTaskNotificationSection.vue?vue&type=template&id=53ff4404&scoped=true"
import script from "./AsynTaskNotificationSection.vue?vue&type=script&lang=ts"
export * from "./AsynTaskNotificationSection.vue?vue&type=script&lang=ts"
import style0 from "./AsynTaskNotificationSection.vue?vue&type=style&index=0&id=53ff4404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ff4404",
  null
  
)

export default component.exports